import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { SelectElement } from "../../../components/selectElement2";
import { serverApi } from "../../../api";

export const ModalReclasificar = ({ show, onClose, onConfirm, ticket, usuario }) => {
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            const fetchTiposAtencion = async () => {
                try {
                    setLoading(true);
                    const codigoEntidad = usuario?.codigoEntidad || localStorage.getItem("codigoEntidad");
                    const codigoUbicacion = usuario?.codigoUbicacion || localStorage.getItem("codigoUbicacion");

                    const resp = await serverApi.post(`/tipos-atencion/select-tiposatencion`, {
                        codigoEntidad,
                        codigoUbicacion
                    });

                    if (resp.data && resp.data.lista) {
                        const ops = resp.data.lista.map(item => ({
                            value: item.uidTipoAtencion,
                            label: `${item.sigla ? `[${item.sigla}] ` : ''}${item.tipoAtencion.toUpperCase()}`
                        }));
                        setOptions(ops);
                    }
                } catch (error) {
                    console.error("Error al obtener tipos de atención:", error);
                } finally {
                    setLoading(false);
                }
            };

            setSelectedOption(null);
            fetchTiposAtencion();
        }
    }, [show, usuario]);

    const handleConfirm = () => {
        if (!selectedOption) return;
        onConfirm(selectedOption.value);
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold">
                    Reclasificar Ticket
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {ticket && (
                    <div className="mb-3 p-3 bg-light rounded-3 text-center border">
                        <div className="fw-bold fs-3 text-primary">
                            {ticket.codigoTipoAtencion}-{ticket.numeroTicket}
                        </div>
                        {ticket.nombrePaciente && (
                            <div className="fw-semibold text-dark mt-1">
                                {ticket.nombrePaciente}
                            </div>
                        )}
                        <div className="text-muted small mt-1">
                            Atención Actual: <strong>{ticket.tipoAtencion}</strong>
                        </div>
                    </div>
                )}

                <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                        Seleccione el Nuevo Tipo de Atención:
                    </Form.Label>
                    <SelectElement
                        options={options}
                        name="tipoAtencionReclasificar"
                        isMulti={false}
                        closeOnMenuSelect={true}
                        value={selectedOption}
                        onChange={(selected) => setSelectedOption(selected)}
                        isClearable={true}
                        placeholder={loading ? "Cargando tipos de atención..." : "Buscar tipo de atención..."}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    variant="warning"
                    className="fw-bold text-dark"
                    onClick={handleConfirm}
                    disabled={!selectedOption || loading}
                >
                    Reclasificar Ticket
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
